/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const formSubmissionDataSchema = z.object({
	id: z.string(),
	formId: z.string(),
	candidateId: z.string(),
	questions: z.array(
		z.object({
			question: z.string(),
			position: z.string(),
			answers: z.array(
				z.object({
					answer: z.string().nullable(),
					optionId: z.string().nullable(),
					updatedAt: z.iso.datetime(),
				}),
			),
			updatedAt: z.iso.datetime(),
			options: z.array(z.object({ id: z.string(), label: z.string() })).nullable(),
		}),
	),
	score: z.object({
		percentage: z.number(),
		total: z.number(),
		max: z.number(),
		breakdown: z.array(
			z.object({
				questionId: z.string(),
				rawScore: z.number(),
				weight: z.number(),
				weightedScore: z.number(),
				maxScore: z.number(),
			}),
		).nullable(),
	}).nullable(),
	thankYouScreen: z.object({
		id: z.string(),
		formId: z.string(),
		minScoreRange: z.number(),
		maxScoreRange: z.number(),
		title: z.string(),
		description: z.string(),
		organisationName: z.string().nullable(),
		logo: z.object({
			id: z.string(),
			name: z.string(),
			fileName: z.string(),
			category: z.union([z.literal('image'), z.literal('file')]),
			mimeType: z.string().nullable(),
			size: z.number(),
			humanReadableSize: z.string(),
			url: z.string(),
			collectionName: z.union([
				z.literal('ad-asset'),
				z.literal('baked-story'),
				z.literal('baked-feed'),
				z.literal('story'),
				z.literal('feed'),
				z.literal('landing-page'),
				z.literal('logo'),
				z.literal('generated'),
				z.literal('uploaded'),
				z.literal('imported'),
				z.literal('candidate-files'),
				z.literal('custom-font'),
				z.literal('design'),
				z.literal('whatsapp-profile'),
			]),
			width: z.number(),
			height: z.number(),
			isPlaceholder: z.boolean(),
			isGenerating: z.boolean(),
			createdAt: z.iso.datetime(),
			isGenerated: z.boolean().default(false),
			startedGenerationAt: z.iso.datetime().nullable(),
			finishedGenerationAt: z.iso.datetime().nullable(),
			meta: z.record(z.string(), z.unknown()).nullable(),
		}).nullable(),
		updatedAt: z.iso.datetime(),
		isGenerated: z.boolean().default(false),
		startedGenerationAt: z.iso.datetime().nullable(),
		finishedGenerationAt: z.iso.datetime().nullable(),
		meta: z.record(z.string(), z.unknown()).nullable(),
	}).nullable(),
	createdAt: z.iso.datetime(),
	updatedAt: z.iso.datetime(),
	meta: z.record(z.string(), z.unknown()).nullable(),
	additionalQuestions: z.array(
		z.object({
			id: z.string(),
			additionalQuestionId: z.string(),
			questionLabel: z.string().nullable(),
			questionType: z.union([
				z.literal('select'),
				z.literal('text'),
				z.literal('open_text'),
				z.literal('file'),
				z.literal('datetime'),
			]).nullable(),
			questionAttribute: z.union([
				z.literal('name'),
				z.literal('email'),
				z.literal('phone'),
				z.literal('contact_consent'),
				z.literal('cv'),
			]).nullable(),
			position: z.number(),
			answers: z.array(
				z.object({
					id: z.string(),
					answer: z.string().nullable(),
					optionId: z.string().nullable(),
					file: z.object({
						id: z.string(),
						candidateId: z.string(),
						name: z.string(),
						fileName: z.string(),
						mimeType: z.string().nullable(),
						size: z.number(),
						url: z.string().nullable(),
						previewUrl: z.string().nullable(),
						createdAt: z.iso.datetime(),
						metadata: z.object({
							sourceEmailId: z.string().nullable(),
							sourceEmailSubject: z.string().nullable(),
						}).nullable(),
						scanStatus: z.union([
							z.literal('queued'),
							z.literal('scanning'),
							z.literal('clean'),
							z.literal('infected'),
							z.literal('error'),
							z.literal('skipped'),
						]).nullable(),
						scanSignature: z.string().nullable(),
						attribute: z.literal('cv').nullable(),
					}).nullable(),
				}),
			),
			createdAt: z.iso.datetime(),
		}),
	),
})

export type FormSubmissionDataSchema = z.infer<typeof formSubmissionDataSchema>
